import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-cream px-5">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md rounded-3xl border border-pink/25 bg-surface p-10 text-center"
        data-testid="payment-cancel-page"
      >
        <XCircle className="mx-auto mb-6 h-12 w-12 text-muted" />
        <h1 className="font-serif text-3xl text-ink">Payment cancelled</h1>
        <p className="mt-3 text-muted font-light">
          No payment was taken. Your booking wasn't completed — you can try again any time.
        </p>
        <Link
          to="/"
          className="mt-8 inline-block rounded-full bg-ink px-8 py-3.5 text-xs uppercase tracking-[0.2em] text-cream hover:bg-inkhover transition-colors"
        >
          Back to Fabrowz
        </Link>
      </motion.div>
    </div>
  );
}
